import { Avatar, Button, Popover, Text } from "../../components";
import { useNavigate } from "react-router-dom";
import Localization from "../../localization";
import { Col, Flex, Row } from "antd";
import { Images } from "../../assets";
import { useAuth } from "../../hooks";
import { Enums } from "../../utils";
import Styled from "./styled";
import React from "react";

const Header = ({ path = "" }) => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <Styled>
      <Row className="w-100">
        <Col span={1} />
        <Col span={22}>
          <Flex justify="space-between" align="center" gap={"2rem"}>
            <img
              className="logo"
              src={Images.fullWhiteLogo}
              onClick={() => navigate("/")}
            />
            {!!isAuthenticated && (
              <Flex gap={"2rem"} align="center">
                {path !== "/feedback" && (
                  <Button
                    color="tertiary"
                    className="feedback-btn"
                    classNames={{ title: "feedback-btn-title" }}
                    title={Localization.general.give_us_feedback}
                    onClick={() => navigate(Enums.pagesNames.feedback)}
                  />
                )}
                <Popover
                  trigger="click"
                  children={
                    <Avatar
                      className="cursor-pointer"
                      image={user.publicProfileRef}
                    />
                  }
                  content={
                    <div>
                      <Text level={4} children={user.alias} />
                      <Text
                        color="secondary"
                        className="m-5-t"
                        children={user.email}
                      />
                      <Button
                        danger
                        color="danger"
                        type="primary"
                        onClick={logout}
                        className="m-25-t"
                        title={Localization.general.logout}
                      />
                    </div>
                  }
                />
              </Flex>
            )}
          </Flex>
        </Col>
        <Col span={1} />
      </Row>
    </Styled>
  );
};

export default Header;
